import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import griffinNumber from 'griffin-paypal/number'
import { get } from 'lodash'
import SelectedFundingOption from './selected-funding-option'
import SendReviewInfo from './send-review-info'
import { shouldShowCurrencyConversionLink } from '../utils/currencyConversionUtils'
import SendCurrencyConversion from './send-currency-conversion'
import content from 'pp-react-l10n'
import { getFlowType } from '../utils/url-utils'
import {
  getCashAdvanceWarningContent,
  getTheFundingSourceWithCashAdvanceFee,
} from './cash-advance-fees-overpanel/cash-advance-fees-util'
import LINKS from '../../../../config/links.json'
let i18n = content('transfer/inc/selectedFundingOption')

class SendSelectedFundingOption extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    fundingOptions: PropTypes.array.isRequired,
    selectedFundingOption: PropTypes.object.isRequired,
    shouldShowCurrencyConversionLink: PropTypes.bool.isRequired,
    selectedInstallmentPlan: PropTypes.object.isRequired,
    isPurchase: PropTypes.bool.isRequired,
    cardSpecs: PropTypes.object.isRequired,
    showDonateContent: PropTypes.bool,
    showCondensedUI: PropTypes.bool,
    isRecurring: PropTypes.bool,
    cvv: PropTypes.string,
    flowType: PropTypes.string,
    conversionType: PropTypes.string,
    contactId: PropTypes.string,
    recipient: PropTypes.string,
    amount: PropTypes.string,
    currencyCode: PropTypes.string,
    fromCurrencyCode: PropTypes.string,
    env: PropTypes.string,
    userAccountType: PropTypes.string,
    isCFPBEnabledCountry: PropTypes.bool,
    addCardSupported: PropTypes.bool,
    isCardArtEnabled: PropTypes.bool,
    pStudioContent: PropTypes.object,
    isReview: PropTypes.bool,
    language: PropTypes.string,
    griffinMetadata: PropTypes.object.isRequired,
    isFeeDisclaimerMessageDisabled: PropTypes.bool,
    checkFeeDisclaimerCountryGrp: PropTypes.bool,
  }

  getFirstTimeUserHelpInfoContentKey = () => {
    let firstTimeUserHelpInfoContentKey
    if (this.props.isPurchase) {
      firstTimeUserHelpInfoContentKey = 'label.newUserFeeInfoGS'
    } else {
      firstTimeUserHelpInfoContentKey = 'label.newUserFeeInfoFF'
    }
    return firstTimeUserHelpInfoContentKey
  }

  render() {
    const firstTimeUserHelpInfoContentKey = this.getFirstTimeUserHelpInfoContentKey()

    const pContent = get(
      this.props.pStudioContent,
      'p2p_cash_advance_fees_inline_warning_touchpoint.content.json',
      {}
    )
    const { funding_sources } = this.props.selectedFundingOption
    const funding_source = getTheFundingSourceWithCashAdvanceFee(
      funding_sources
    )

    const generic_issuer_name =
      funding_source && funding_source.generic_issuer_name

    const chargesTransactionPercent = {
      allCountriesCharges: 0.5,
      AustraliaAndPolandCharges: 1.0,
      GermanyCharges: 2.0,
      JapanCharges: 0.3,
      MexicoCharges: 0.5,
    }

    const griffinNumberHandler = griffinNumber.createHandler(
      this.props.griffinMetadata
    )

    Object.keys(chargesTransactionPercent).forEach(key => {
      let charges = chargesTransactionPercent[key] / 100
      let normalizedNumber = griffinNumberHandler.formatNumber(charges, {
        style: 'percent',
        minimumFractionDigits: 1,
      })
      chargesTransactionPercent[key] = normalizedNumber
    })

    return (
      <SelectedFundingOption
        dispatch={this.props.dispatch}
        showDonateContent={this.props.showDonateContent}
        showCondensedUI={this.props.showCondensedUI}
        fundingOptions={this.props.fundingOptions}
        selectedFundingOption={this.props.selectedFundingOption}
        shouldShowCurrencyConversionLink={
          this.props.shouldShowCurrencyConversionLink
        }
        selectedInstallmentPlan={this.props.selectedInstallmentPlan}
        firstTimeUserHelpInfoContent={i18n.html(
          firstTimeUserHelpInfoContentKey,
          {
            ...chargesTransactionPercent,
            valueSymbol: '%',
            addBankUrl: LINKS.ALL.ADD_BANK_URL,
          }
        )}
        reviewInfoComponent={<SendReviewInfo />}
        currencyConversionComponent={
          <SendCurrencyConversion
            shouldShowCurrencyConversionLink={
              this.props.shouldShowCurrencyConversionLink
            }
            isReview={this.props.isReview}
            isFeeDisclaimerMessageDisabled={
              this.props.isFeeDisclaimerMessageDisabled
            }
          />
        }
        cardSpecs={this.props.cardSpecs}
        isPurchase={this.props.isPurchase}
        isRecurring={this.props.isRecurring}
        flowType={this.props.flowType}
        cvv={this.props.cvv}
        conversionType={this.props.conversionType}
        contactId={this.props.contactId}
        recipient={this.props.recipient}
        amount={this.props.amount}
        currencyCode={this.props.currencyCode}
        fromCurrencyCode={this.props.fromCurrencyCode}
        addCardSupported={this.props.addCardSupported}
        env={this.props.env}
        isCFPBEnabledCountry={this.props.isCFPBEnabledCountry}
        userAccountType={this.props.userAccountType}
        isCardArtEnabled={this.props.isCardArtEnabled}
        cashAdvanceWarningContent={getCashAdvanceWarningContent(
          pContent,
          generic_issuer_name
        )}
        warningLabelOnClick={this.handleShowCashAdvanceFeeOverpanel}
        language={this.props.language}
      />
    )
  }
}

export default connect(
  ({
    transaction,
    user,
    amount,
    server,
    card,
    external,
    recipient,
    overpanels,
    crossBorder,
  }) => ({
    fundingOptions: transaction.fundingOptions,
    selectedFundingOption: transaction.selectedFundingOption,
    cvv: transaction.cvv,
    shouldShowCurrencyConversionLink: shouldShowCurrencyConversionLink(
      transaction.selectedFundingOption
    ),
    isPurchase: transaction.isPurchase,
    conversionType: transaction.conversionType,
    cardSpecs: card.cardSpecs,
    showDonateContent:
      external.showDonateContent || transaction.isCrowdFundingCampaign,
    addCardSupported: external.addCardSupported,
    showCondensedUI: external.showCondensedUI,
    isRecurring: external.isRecurring,
    // installments for BR and MX
    selectedInstallmentPlan: transaction.selectedInstallmentPlan, // TODO: should installments be `connect`ed?
    contactId: recipient.contactId,
    recipient: recipient.recipient,
    amount: amount.amount,
    currencyCode: amount.currencyCode,
    fromCurrencyCode: amount.fromCurrencyCode,
    env: server.env,
    isCFPBEnabledCountry: server.isCFPBEnabledCountry,
    userAccountType: server.userAccountType,
    flowType: getFlowType(),
    isCardArtEnabled: server.features && server.features.isCardArtEnabled,
    pStudioContent: server.pStudioContent,
    language: user.language,
    griffinMetadata: server.griffinMetadata,
    isFeeDisclaimerMessageDisabled: crossBorder.disableFeeDisclaimerMessage,
  })
)(SendSelectedFundingOption)
